interface NavigationUser {
  is_hoeppner?: boolean
  is_hmc_admin?: boolean
  can_view_dashboard?: boolean
}

interface NavigationCustomer {
  is_registry?: boolean
  is_dangergoods_registry?: boolean
  is_processmanager?: boolean
}

interface NavigationItem {
  url?: string
  is_authorized?: boolean
  hmc_admin_only?: boolean
}

export function isMainNavigationItemVisible(item: NavigationItem, user: NavigationUser | null | undefined) {
  if (item.hmc_admin_only) return user?.is_hmc_admin === true
  if (item.url === "registry.pflichten") return item.is_authorized === true

  return user?.is_hoeppner === true || item.is_authorized === true
}

export function canAccessDashboard(
  user: NavigationUser | null | undefined,
  customer: NavigationCustomer | null | undefined,
) {
  return user?.is_hoeppner === true || (
    user?.can_view_dashboard === true && customer?.is_registry === true
  )
}

export function defaultRegistryView(
  user: NavigationUser | null | undefined,
  customer: NavigationCustomer | null | undefined,
) {
  if (canAccessDashboard(user, customer)) return "registry.dashboard"
  if (customer?.is_registry === true) return "registry.rechtsgrundlagen"
  if (customer?.is_dangergoods_registry === true) return "registry.gefahrstoffe"
  if (customer?.is_processmanager === true) return "registry.process_management"
  return "desktop"
}

export function authorizedRegistryView(
  view: string,
  user: NavigationUser | null | undefined,
  customer: NavigationCustomer | null | undefined,
) {
  if (view === "registry.dashboard" && !canAccessDashboard(user, customer)) {
    return defaultRegistryView(user, customer)
  }
  if (view === "registry.roles" && user?.is_hmc_admin !== true) {
    return defaultRegistryView(user, customer)
  }
  return view
}
